module.exports = __webpack_public_path__ + "img/left_training_2.6b3b406d.svg";